module.exports = require("./zh-Hans.js");